/**
 * Plugin to automatically transform image src attributes to use Cloudinary CDN
 * Works on both server and client side
 */
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const cloudBase: string = (config.public as any)?.cloudinaryBaseURL || 'https://res.cloudinary.com/ommi-shop/image/upload'

  // Get mapping - different approach for server vs client
  let mapping: Record<string, string> = {}
  
  if (import.meta.server) {
    // Server-side: read from file
    try {
      const fs = require('node:fs')
      const path = require('node:path')
      const mappingPath = path.resolve(process.cwd(), 'data', 'public-images.json')
      if (fs.existsSync(mappingPath)) {
        const raw = fs.readFileSync(mappingPath, 'utf-8')
        mapping = JSON.parse(raw || '{}')
      }
    } catch (e) {
      // Ignore errors
    }
  } else {
    // Client-side: get from window global
    // @ts-ignore
    mapping = window.__publicImagesMapping || {}
  }

  /**
   * Transform a local image path to Cloudinary URL if mapping exists
   */
  const transformImageSrc = (src: string): string => {
    if (!src || !src.startsWith('/')) return src
    
    const cloudinaryPublicId = mapping[src]
    if (cloudinaryPublicId) {
      // Extract extension from original path
      const extMatch = src.match(/\.[^.]+$/)
      const ext = extMatch ? extMatch[0] : ''
      // Always append extension - Cloudinary may have stored with double extension (.jpg.jpg)
      // when we uploaded with extension in public_id, so we need to match that
      const publicIdWithExt = ext ? `${cloudinaryPublicId}${ext}` : cloudinaryPublicId
      // Build Cloudinary URL with WebP optimization
      return `${cloudBase}/f_auto,q_auto/${publicIdWithExt}`
    }
    
    return src
  }

  // Make it available globally for use in components
  return {
    provide: {
      cdnImage: transformImageSrc
    }
  }
})

